import { render, staticRenderFns } from "./ProductNotifiedTable.vue?vue&type=template&id=4979b5f9&scoped=true"
import script from "./ProductNotifiedTable.vue?vue&type=script&lang=js"
export * from "./ProductNotifiedTable.vue?vue&type=script&lang=js"
import style0 from "./ProductNotifiedTable.vue?vue&type=style&index=0&id=4979b5f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4979b5f9",
  null
  
)

export default component.exports